module.exports = __webpack_public_path__ + "img/collect.e9a65a3c.png";